import { useState, useRef } from 'react'
import { faCloudArrowUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ThumbnailCropperModal from './ThumbnailCropperModal'

const ThumbnailInput = ({
  inputRef,
  placeholder,
  currentImageUrl,
  onChange,
}) => {
  const internalRef = useRef(null)
  const ref = inputRef || internalRef

  const [imageSrc, setImageSrc] = useState(null)
  const [previewUrl, setPreviewUrl] = useState(currentImageUrl || null)
  const [showCropper, setShowCropper] = useState(false)

  const handleFileSelect = (e) => {
    const file = e.target.files[0]
    if (!file) return
    const reader = new FileReader()
    reader.onload = () => {
      setImageSrc(reader.result)
      setShowCropper(true)
    }
    reader.readAsDataURL(file)
  }

  const handleCropComplete = (croppedFile) => {
    setShowCropper(false)

    // Create object URL for display
    const url = URL.createObjectURL(croppedFile)
    setPreviewUrl(url)

    if (onChange) {
      // State-based flow (e.g. queue items)
      onChange(croppedFile)
    }

    if (ref && ref.current) {
      // Form-based flow — inject cropped file into native input via DataTransfer
      try {
        const dt = new DataTransfer()
        dt.items.add(croppedFile)
        ref.current.files = dt.files
      } catch (_) {
        // DataTransfer not supported (old browsers) — onChange already called above
      }
    }
  }

  const handleCropCancel = () => {
    setShowCropper(false)
    setImageSrc(null)
    // Reset the native input so the same file can be re-selected
    if (ref && ref.current) {
      ref.current.value = ''
    }
  }

  const handleRemove = () => {
    setPreviewUrl(null)
    setImageSrc(null)
    if (ref && ref.current) {
      ref.current.value = ''
    }
    if (onChange) {
      onChange(null)
    }
  }

  return (
    <>
      {/* Hidden native file input — used by form-based actions via ref */}
      <input
        ref={ref}
        type='file'
        name='thumbnail'
        accept='image/*'
        style={{ display: 'none' }}
        onChange={handleFileSelect}
      />

      {previewUrl ? (
        <div className='d-flex align-items-center'>
          <div
            style={{
              width: 52,
              height: 52,
              borderRadius: 6,
              overflow: 'hidden',
              border: '2px solid #dee2e6',
              flexShrink: 0,
              position: 'relative',
            }}
          >
            <img
              src={previewUrl}
              alt='thumbnail'
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          </div>
          <div className='d-flex flex-column ml-2'>
            <button
              type='button'
              className='btn btn-sm btn-outline-primary mb-1'
              style={{ fontSize: 11, padding: '2px 8px' }}
              onClick={() => {
                if (ref && ref.current) {
                  ref.current.value = ''
                  ref.current.click()
                }
              }}
            >
              Change
            </button>
            <button
              type='button'
              className='btn btn-sm btn-outline-danger'
              style={{ fontSize: 11, padding: '2px 8px' }}
              onClick={handleRemove}
            >
              Remove
            </button>
          </div>
        </div>
      ) : (
        <div className='upload-video-form-row'>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: '#37c2de',
              color: '#fff',
              borderRadius: 4,
              padding: '10px 20px',
              cursor: 'pointer',
              userSelect: 'none',
              fontSize: 14,
            }}
            onClick={() => ref.current && ref.current.click()}
          >
            <FontAwesomeIcon icon={faCloudArrowUp} className='mr-2' />
            {placeholder || 'Choose thumbnail'}
          </div>
        </div>
      )}

      {showCropper && imageSrc && (
        <ThumbnailCropperModal
          imageSrc={imageSrc}
          onCropComplete={handleCropComplete}
          onCancel={handleCropCancel}
        />
      )}
    </>
  )
}

export default ThumbnailInput
